module.exports = __webpack_public_path__ + "static/media/sns-icon-insta.e05ba7f6.svg";